<script lang="ts">
	import BaseNode from './BaseNode.svelte';
	import type { FlowNodePort } from '../helpers/flowBranchHandleStyles';
	import type { NodeData } from '../types/flow-types';
	import { resolveNotificationCardPresentation } from '../helpers/notificationDisplay';

	export let id: string;
	export let data: NodeData;
	export let selected: boolean = false;
	export let validated: boolean = true;
	export let errors: string[] = [];

	$: notificationType = String(data.notificationType || 'push_notification');
	$: presentation = resolveNotificationCardPresentation(data);
	$: inputPorts = [{ id: 'input', centered: true }] satisfies FlowNodePort[];

	// Get icon based on notification type
	$: notificationIcon =
		notificationType === 'mail_notification'
			? 'fa-envelope'
			: notificationType === 'push_notification'
				? 'fa-bell'
				: notificationType === 'event_log'
					? 'fa-clipboard-list'
					: notificationType === 'alexa_notif'
						? 'fa-volume-up'
						: 'fa-bell';
</script>

<BaseNode
	{id}
	type="notificationAction"
	{data}
	{selected}
	{validated}
	{errors}
	{inputPorts}
	hideOutputPort={true}
	cardTitle={presentation.title}
	nodeTypeLabel={presentation.subtitle}
	avatarOverride={{
		icon: `fa-solid ${notificationIcon}`,
		backgroundColor: 'color-green',
	}}
	{...$$restProps}
/>
